export enum PriceStatus {
  Default = 'default',
  Positive = 'positive',
  Negative = 'negative',
}

export enum Status {
  Disabled = 'disabled',
}

/** ((current - reference) / reference) * 100 */
export const percentChangeFromReference = (
  current: number | undefined,
  reference: number | undefined
) => {
  if (current === undefined || reference === undefined || reference === 0) {
    return undefined;
  }

  return ((current - reference) / reference) * 100;
};

export const formatPercentage = (
  n: number,
  options?: Partial<{
    decimals: number;
    suffix: string;
    useOriginalValue: boolean;
    addPlus: boolean;
  }>
) => {
  let {
    decimals = 2,
    suffix = '',
    useOriginalValue,
    addPlus = false,
  } = options ?? {};
  const calculatedValue = (n * (useOriginalValue ? 1 : 100)).toFixed(decimals);

  if (suffix === 'bps') {
    suffix = Math.abs(+calculatedValue) === 1 ? 'bp' : 'bps';
  }

  const formattedValue = `${calculatedValue}${suffix}`;

  return addPlus && n > 0 ? `+${formattedValue}` : formattedValue;
};

export function numberWithCommas(x: number | string): string {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function numberRoundedToPrecision(num: number, precision = 2) {
  return Number(num.toFixed(precision));
}

export const cryptoRandom = () => {
  const crypto = window.crypto;
  const array = new Uint32Array(1);
  return crypto.getRandomValues(array)[0];
};

export const getPriceStatus = (value?: number) => {
  if (!value) {
    return PriceStatus.Default;
  }

  return value > 0 ? PriceStatus.Positive : PriceStatus.Negative;
};
